$('.footer-block__image-wrapper').click(function(){
     $("html").animate({ scrollTop: 0 }, "slow");
});
$(document).on("click", ".sub_custom_widget .cms_box", function(event) { 
    var inputElement = $(this).find('input');
    
    if (inputElement.is(':checked')) {
        // Uncheck all inputs within the closest .sub_custom_widget
        $(this).closest('.sub_custom_widget').find('input').prop('checked', false);
    } else {      
       $(".message_pop_up .custom-model-main").addClass('model-open');
       $(this).closest('.sub_custom_widget').find('input').prop('checked', true);
    }
});

$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});



$(document).on("click",".btn_wrap_login .cartbuttonnew",function(e) {
e.preventDefault();
   $(".account_pp .custom-model-main").addClass('model-open');
});




$(document).ready(function(){

var cartdrawer=$(".cart-drawer").attr("cart_drawer_on");
if(cartdrawer == 'true'){
$(".header__icon.header__icon--cart").addClass("site-header__cart");
$(".cart_button_custom").addClass("cart_drawer_custom_code");
$(".cart_button_custom").removeClass("redirecttocart");
}
else{
$(".header__icon.header__icon--cart").removeClass("site-header__cart");
$(".cart_button_custom").removeClass("cart_drawer_custom_code");
$(".cart_button_custom").addClass("redirecttocart");
}  
   
  
});  
/* Cart Note */   
$(".tax_section.order_note span.note_open").click(function(){
$(this).toggleClass("active");
$(".oder_note_texarea").toggleClass("active");
});
  
/* Checkout Button Redirection Code */ 
$(document).on("click",".check .cartbuttonnew",function(){
       
 var cartnote = $(".cart_note").val();
  var data = {
        note:cartnote
};  
  
  $.ajax({
    url:'/cart/update.js',
     type:"POST",
     dataType: 'JSON',
     data:data,
    success:function(res){
    window.location.href="/checkout"; 
}
   });
  
  
        
       
 
     
});
  
function updateCart(){
var currencySymbol = window.currencySymbol;

var cartdrawer=$(".cart-drawer").attr("cart_drawer_on");
if(cartdrawer == 'true'){
$(".header__icon.header__icon--cart").addClass("site-header__cart");
$(".cart_button_custom").addClass("cart_drawer_custom_code");
$(".cart_button_custom").removeClass("redirecttocart");
}
else{
$(".header__icon.header__icon--cart").removeClass("site-header__cart");
$(".cart_button_custom").removeClass("cart_drawer_custom_code");
$(".cart_button_custom").addClass("redirecttocart");
}  
  
    $.ajax({
    url:'/cart.js',
     type:"GET",
     dataType: 'JSON',
    success:function(res){
      console.log(res);
      
     var note=res['note'];
     $(".cart_note").attr("value",note);
     console.log("note");
      
      
       var items=res['items'];
       var cond=items.length;
       var item_count=res.item_count;
        $(".cart-count-bubble span:eq(0)").text(item_count);
       $(".cart-count-bubble span:eq(1)").text(item_count+" items");
      if(cond==0)
      {
      $(".price-sec").hide();
      $(".shipping").hide();
      $(".cart-drawer-empty").show();
      $(".cart-drawer-sec").addClass("heights");
      $(".this-close").show();
       $('.check_btn_bottom').hide();
      }
    else
      {
        
      $(".price-sec").show();
      $(".shipping").show();
      $(".cart-drawer-empty").hide();
      $(".this-close").hide();
         $('.check_btn_bottom').show();
      }
     var finalprice=parseFloat(res['total_price']/100);
     var finalprice = finalprice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); 
     var finalprice = finalprice.replace(",",","); 
     $(".subtotal-sec .total-price").remove();
      
      
      var shipping_price= $(".shipping_custom_calculate").attr("qly_price");
      var shipping_total=parseInt(shipping_price-finalprice);
      var finalpriceshipis=Math.abs(finalprice);
      
      var progressbar=parseInt(finalprice) + parseInt(150);
            $(".cart-drawer .shipping_custom_calculate").show();
      $(".cart-drawer .shipping_custom_calculate .custom_calculate").html('');
      if(parseInt(finalprice) < parseInt(shipping_price)){
        $(".cart-drawer .shipping_custom_calculate .custom_calculate").append(shipping_total);
            $(".shipping_custom_calculate_less").hide();
        $("span.inner_progressbar").css("width", progressbar);
        
      }
      else{
      $(".shipping_custom_calculate_less").show();
      $(".cart-drawer .shipping_custom_calculate").hide();
       }
      
      
     $(".cart-drawer .subtotal-sec").append("<div class='total-price'>"+currencySymbol+finalprice+"</div>");
     var itemcount=res['item_count'];
     
      setTimeout(function(){
       $(".site-header__cart-count span").text(itemcount);
         $(".site-header__cart-count").removeClass("hide");
      },1000);
      
      var i; var j;
      $(".content-block").remove();
      $('.cart-drawer-sec .bottom').append("<div class='content-block'></div>");
      var line_item_id = '1';
       var token=0;
      
      for(i=0;i<items.length;i++){
        
      var title=items[i]['product_title'];   
      var producturl=items[i]['url'];   
      var price=parseFloat(items[i]['price']/100);
      var price = price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); 
      var price = price.replace(",",",");
      var final_price = items[i]['final_price'];
        
      var price_new=parseFloat(items[i]['price']/100);
      var discount=parseFloat(items[i]['total_discount']/100);
      var discount=((price_new) - (discount));
      var discount=discount.toFixed(2);
      var discount = discount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); 
      var discount = discount.replace(",",",");
      var img=items[i]['image'];
     var qty=items[i]['quantity'];
     var product_id=items[i]['product_id'];
      var variant_id=items[i]['variant_id'];
      var key=items[i]['key']; 
      var sku=items[i]['sku']; 
        var sell_item=items[i]['selling_plan_allocation']; 
    var price_line=parseFloat(items[i]['final_line_price']/100);
      var price_line = price_line.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); 
      var price_line = price_line.replace(",",",");
        
        if ( typeof sell_item === 'undefined' ) {
}else{
   var sell_name = sell_item.selling_plan.name;
console.log(sell_name);       
}
 
       console.log('price_line8888888888888888888888', price_line);
        var property1 = items[i]['properties']['_freeID'];
   $('.cart-drawer-sec .bottom .content-block').append("<div class='part loop-"+i+"' data-id='"+i+"' product-id='"+product_id+"' var-id='"+variant_id+"' key='"+key+"' prop='"+property1+"'  final_price='"+final_price+"' ></div>");
   $(".cart-drawer-sec .bottom .content-block .loop-"+i).append("<div class='image'></div>");
   $(".cart-drawer-sec .bottom .content-block .loop-"+i).append("<div class='content'></div>");
   $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content").append("<div class='titlesec'></div>");
        $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content").append("<div class='price-only'></div>");
        if(final_price == '0' || final_price == 0){
          
        }else{
            $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content").append("<div class='quantitybox'></div>"); 
        }

        
   // $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content").append("<div class='sku'></div>");
   $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content").append("<div class='sell_plan'></div>");
   $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .image").append("<div class='img-own-cart'><img src="+img+" class='own-cart-image'></div>");
   $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .titlesec").append("<div class='title'><a href='"+producturl+"'>" +title+ "</a></div>");

   
        if(final_price == '0' || final_price == 0){
          
        }else{
                $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .titlesec").append("<div class='price-with-title price price--end'>" +currencySymbol+price+ "</div>");
            $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .price-only").append("<div data-price='"+price+"' class='price'>"+currencySymbol+price_line+ "</div>");
         $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .quantitybox").append("<div class='rightnew quantity'><button class='minus_quantity quantity__button' data-id='"+line_item_id+"'>-</button><input type='number' class='cart__qty-input quantity__input' data-id='"+line_item_id+"' value="+qty+" min='0' pattern='[0-9]*'><button class='plus_quantity quantity__button' data-id='"+line_item_id+"'>+</button></div>");
$(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .quantitybox").append(`
  <div class='remove' data-id=${i}>
    <button class='btn' type='button'>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
        <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>
        <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>
      </svg>
    </button>
  </div>
`);
          }
       
        var variant_names = items[i]['options_with_values'];
        var k;
        for(k=0;k<variant_names.length;k++){
         var variant_name = variant_names[k]['name'];
         var variant = variant_names[k]['value'];
          if(variant != null ){
            if(variant.indexOf("Title") == -1){
                 $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content").append("<div class='varintbox'></div>");
             $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .varintbox").append("<div class='vartitle_size'>" +variant_name+ ":</div>");
             $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .varintbox").append("<div class='vartitle'>" +variant+ "</div>");
            }
          }
          
        } 
        
          
       var property = items[i]['properties'];      
       if(property != null ){
         var frequency_num = items[i]['properties']['frequency_num'];
          if(frequency_num != undefined){
                  $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .titlesec").append("<div class='num'>Every " +frequency_num+ " </div>");
          }
          
          var frequency_type_text = items[i]['properties']['frequency_type_text'];
          if(frequency_type_text != undefined){
              $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .titlesec").append("<div class='mnts'>" +frequency_type_text+ " </div>");
          }
           var properties = items[i]['properties']['group_id'];
            if(properties != undefined){
                token=1;
           }
         }
        
   $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .quantitybox").append("<span>x"+qty+"</span>");
  
    
        var line_item_id = parseInt(line_item_id)+parseInt(1); 
      

       $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .sku").text(sku);
         if ( typeof sell_item === 'undefined' ) {
}else{
         $(".cart-drawer-sec .bottom .content-block .loop-"+i+" .content .sell_plan").text(sell_name);
        }
      }
      
     $(".cart-drawer-sec").append("<input class='datasub' type='hidden' value="+token+">"); 
}
     
 });
  }
  

  
/*Open  Cart Drawer On Header Cart Icon */ 
$(document).on("click","a.header__icon.header__icon--cart",function( e ){ 
     e.preventDefault();
  $(".price-sec").show();
      $(".shipping").show();
   $(".cart-drawer-empty").hide();
  
   $('body').addClass("js-drawer-open-right");
   $.ajax({
    url:'/cart.js',
     type:"GET",
     dataType: 'JSON',
    success:function(res){
        updateCart(); 
}
     
 });
 
    
 
  
  
});

/* Cartdrawer plus quantity */    
$(document).on("click", "button.plus_quantity", function(event) {
    event.preventDefault(); 
    
    var data_id = $(this).attr('data-id');
    var $button = $(this);
     var $part = $button.closest('.part');
     var prop = $part.attr('prop'); 
 
  
   var qty = parseInt($(".cart__qty-input[data-id='"+data_id+"']").val()) + 1;
var keydefault = $part.attr('key'); 
  var varint_id = $part.attr('var-id'); 
  
      var key = [];
if ( prop == 'undefined') {


 key.push(keydefault); 
}else{
   // var var_id = [];
   key.push(keydefault); 
    $('.content-block .part[var-id="' + prop + '"]').each(function() {
    var final_price = $(this).attr('final_price'); 
     if(final_price == '0' || final_price == 0){
      var key1 = $(this).attr('key');      
         key.push(key1); 
     }
    });
} 
   let updates = key.reduce((acc, id) => {
  acc[id] = qty; 
  return acc;
}, {}); 
  fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
 updateCart(); 
})
.catch((error) => {
  
});
  
     
});




   
/* Cart drawer minus quantity */
$(document).on("click","button.minus_quantity",function(){
event.preventDefault(); 
    var data_id = $(this).attr('data-id');
    var $button = $(this);
     var $part = $button.closest('.part');
     var prop = $part.attr('prop'); 
   var qty = parseInt($(".cart__qty-input[data-id='"+data_id+"']").val()) - 1;
    var keydefault = $part.attr('key'); 
  var varint_id = $part.attr('var-id'); 
  
      var key = [];
if ( prop == 'undefined') {


 key.push(keydefault); 
}else{
   // var var_id = [];
   key.push(keydefault); 
    $('.content-block .part[var-id="' + prop + '"]').each(function() {
    var final_price = $(this).attr('final_price'); 
     if(final_price == '0' || final_price == 0){
      var key1 = $(this).attr('key');      
         key.push(key1); 
     }
    });
} 
   let updates = key.reduce((acc, id) => {
  acc[id] = qty; 
  return acc;
}, {}); 
  fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
 updateCart(); 
})
.catch((error) => {
  
});
 });
  
  
/* Cart drawer remove button */ 
$(document).on("click", ".content-block .remove", function() {     
    var data_id = $(this).closest('.remove').attr('data-id');  
     var $button = $(this);
     var $part = $button.closest('.part');
     var prop = $part.attr('prop'); 
   var keydefault = $part.attr('key'); 
  var varint_id = $part.attr('var-id'); 
  
    var qty = 0;
      var key = [];
if ( prop == 'undefined') {


 key.push(keydefault); 
}else{
   // var var_id = [];
   key.push(keydefault); 
    $('.content-block .part[var-id="' + prop + '"]').each(function() {
    var final_price = $(this).attr('final_price'); 
     if(final_price == '0' || final_price == 0){
      var key1 = $(this).attr('key');      
         key.push(key1); 
     }
    });
} 
    let updates = key.reduce((acc, id) => {
  acc[id] = 0; 
  return acc;
}, {});  
 
 fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
updateCart(); 
})
.catch((error) => {
  
});  

});

/* Cartdrawer close */    
$(document).on("click",'.cart-drawer .close',function(){
    $('body').removeClass('js-drawer-open-right');    
        
});


$(document).on("click", 'form:not(#ContactForm) form:not(#ContactFooter) button[type="submit"]', function(e) {
    // Prevent the default submit action
    e.preventDefault();

    var btn = $(this).attr('click');
    $('body').addClass("js-drawer-open-right");
    var formdata = $(this).closest('form').serialize();
    
    // Make the AJAX request
    $.ajax({
        url: "/cart/add.js",
        type: "POST",
        data: formdata,
        dataType: "JSON",
        success: function(result) {
            updateCart(); 
        }
    });
});


$(".addOnProduct").on("click", function () {
    let varId = $(this).attr("varid"); // Use $(this) to get the clicked element
    let formData = {
        items: [{
            id: varId,
            quantity: 1
        }]
    };

    $.ajax({
        url: window.Shopify.routes.root + "cart/add.js",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(formData),
        success: function (response) {
            console.log("Response:", response);
          $('body').addClass("js-drawer-open-right");
          updateCart(); 
        },
        error: function (xhr, status, error) {
            console.error("Error:", error);
        }
    });
});


function isEmpty(value) {
    return (
        value === undefined || // Check if undefined
        value === null ||      // Check if null
        value === '' ||        // Check if an empty string
        (Array.isArray(value) && value.length === 0) || // Check if an empty array
        (typeof value === 'object' && Object.keys(value).length === 0) // Check if an empty object
    );
}

